import axios from "axios";

export default axios.create({
  baseURL: "https://sap.wegosecure.com/api/moveon",
  headers: {
    "Content-type": "application/json",
  },
});
